import { useMutation } from '@tanstack/react-query'
import api from '@/lib/api'
import { useAccessToken } from '@/features/auth/state/auth'

export function useCreateSignature() {
  const token = useAccessToken()

  return useMutation({
    mutationFn: async ({
      id_client,
      fotoPessoa,
      fotoDoc,
      local,
      maquina
    }: {
      id_client?: string
      fotoPessoa: File
      fotoDoc: File
      local?: string
      maquina?: string
    }) => {
      if (!token) throw new Error('Token está ausente')
      if (!fotoPessoa || !fotoDoc) throw new Error('Fotos são obrigatórias.')
      const formData = new FormData()
      formData.append('fotoPessoa', fotoPessoa)
      formData.append('fotoDoc', fotoDoc)
      if (!id_client) throw new Error('CNPJ não encontrado para assinatura')
      formData.append('id', id_client)
      formData.append('local', local || '')
      formData.append('maquina', maquina || '')

      const response = await api.post('/signatures/user', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`
        }
      })

      if (!response.data) throw new Error('Erro ao criar assinatura')
      return response.data
    }
  })
}
